module.exports = __webpack_public_path__ + "img/landing2-c.cb1dc6cb.jpg";